// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__t+vpa","logo-full":"Logo_logo-full__p+GOi"};